module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = 1015
// module chunks = 1